import { render, staticRenderFns } from "./CustomerAutocomplete.vue?vue&type=template&id=e31a8c46"
import script from "./CustomerAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerAutocomplete.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports